import { ResetPasswordSendOtpNamespace } from '@core/models/client';

export namespace ResetPasswordSendOtpApiNamespace {
  export class IN {
    login: string = '';
    password: string = '';
    confirmPassword: string = '';
    recaptchaToken: string = '';
    constructor(input: ResetPasswordSendOtpNamespace.IN) {
      this.login = input.login;
      this.password = input.password;
      this.confirmPassword = input.passwordConfirm;
      this.recaptchaToken = input.recaptchaToken;
    }
  }

  export class OUT {
    recoverPasswordKey: string = '';
  }
}
